<template>
  <div class="row">
      <div class="flex xs12">
        <va-card title="留学文章列表">
          <div class="row align--center mb-1">
            <div class="flex xs12 sm6">
              <va-input
                class="ma-0"
                :value="title"
                placeholder="search by title"
                @input="search"
                removable
              >
                <va-icon name="fa fa-search" slot="prepend"/>
              </va-input>
            </div>
            <div class="flex xs12 sm6">
              <div class="d-flex justify--end">
                <va-button color="info" small :to="{ name: 'savePost' }">新增留学文章</va-button>
              </div>
            </div>
          </div>
          <va-data-table
            :fields="fields"
            :data="filteredData"
            :loading="loading"
            :totalPages="totalPages"
            @page-selected="listPost"
            api-mode
          >
            <template slot="sort" slot-scope="props">
              <va-input
                v-model="props.rowData.sortNum"
                type="number"
                :min="1"
              >
                <va-button slot="append" icon="ion-md-checkmark ion" color="info" small @click="updateSortNum(props.rowData)">
                </va-button>
              </va-input>
            </template>

            <template slot="type" slot-scope="props">
              <va-badge >
                {{ computeType(props.rowData.type).text }}
              </va-badge>
            </template>

            <template slot="actions" slot-scope="props">
              <va-button flat small color="gray" icon="fa fa-pencil"
                :to='{path:`savePost/${props.rowData.id}`}'/>
              <va-button flat small color="gray" icon="fa fa-trash"
                @click="deleteModal=true;deleteId=props.rowData.id"/>
            </template>
          </va-data-table>
          <va-modal
            v-model="deleteModal"
            title="删除留学文章"
            okText="提交"
            position="center"
            message="请再次确认是否要删除？"
            @ok="confirmDelete"
          />
        </va-card>
      </div>
    </div>
  </template>

  <script>

  import debounce from 'lodash/debounce'
  import postApi from '../../../api/liuxue/post'

  export default {
    data () {
      return {
      message: ['Required field'],
        post: [],
        title: '',
        loading: true,
        pageSize: 10,
        totalPages: 1,
        deleteId: null,
        deleteModal: false,
      }
    },
    computed: {
      fields () {
        return [
          {
            name: '__slot:sort',
            title: '排序',
            width: '10%',
          },
          {
            name: '__slot:type',
            title: '类型',
            width: '10%',
          },
          {
            name: 'title',
            title: '标题',
            width: '30%',
          },
          {
            name: 'desc',
            title: '简短描述',
            width: '40%',
          },
          {
            name: '__slot:actions',
            width: '10%',
            dataClass: 'text-left',
          },
        ]
      },
      filteredData () {
        if (!this.title || this.title.length < 1) {
          return this.post
        }
        return this.post.filter(item => {
          return item.title.toLowerCase().startsWith(this.title.toLowerCase())
        })
      },
    },
    created () {
      this.listPost()
    },
    methods: {
      listPost (pageNumber = 1) {
        this.loading = true
        const params = {
          pageSize: this.pageSize,
          pageNumber: pageNumber,
        }
        postApi.listPost(params)
          .then(response => {
            this.post = response.posts
            this.totalPages = response.totalPage
            this.loading = false
          })
      },
      confirmDelete () {
        postApi.deletePost(this.deleteId).then(response => {
          this.listPost()
        })
      },
      search: debounce(function (title) {
        this.title = title
      }, 400),
      updateSortNum: function (params) {
        postApi.updatePost(params.id, params).then(response => {
          if (response.success === true) {
            this.listPost()
          }
        }).catch(error => alert(error))
      },
      computeType: function (type) {
        const data = {
            color: 'success',
            text: '图文',
        }
        if (type === 2) {
            data.color = 'danger'
            data.text = '视频'
        }
        return data
      },
    },
  }

  </script>
  <style lang="scss">
  .data-table-server-pagination---avatar {
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
  </style>
